module.exports = __webpack_public_path__ + "img/V53.448a3a22.jpg";